<div class="audience-users-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div *ngIf="experience">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ experience.name }}</h5>
                        <h2>{{ 'ENGAGE.MEMBER.TITLE.PLURAL' | translate }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </mat-toolbar>
    <div class="audience-users">
        <div class="audience-users-toolbar pb-12" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayoutAlign="space-between center" fxLayoutAlign.gt-xs="end center" *ngIf="selectedUserIds$ | async; let selectedUserIds">
                <app-search-outline [searchInput]="searchInput" *ngIf="!selectedUserIds.length"></app-search-outline>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <app-flat-button class="mr-8" [icon]="'add'" [label]="'ENGAGE.BUTTONS.ADD_USERS'" (onClick)="openDialogAddUsers()"></app-flat-button>
                <app-white-button
                    class="mr-8"
                    [icon]="'drive_file_move'"
                    [label]="'GENERAL.BUTTON.MOVE_TO'"
                    [disabled]="!(selectedUserIds$ | async).length"
                    (onClick)="openDialogMoveUsers()"
                    [showThreeDots]="true"
                ></app-white-button>
                <app-white-button [disabled]="!(selectedUserIds$ | async).length" [label]="'GENERAL.BUTTON.REMOVE'" (onClick)="deleteExperienceUsers()"></app-white-button>
            </div>
        </div>
        <div class="mb-32 content white" *ngIf="experience">
            <app-experience-users-list
                [experienceId]="experience.id"
                [experienceName]="experience.name"
                [sortBy]="sortBy"
                [sortOrder]="sortOrder"
                [loadUser$]="loadUser$"
                [user$]="users$"
                [isFetchingExperienceUsers$]="isFetchingExperienceUsers$"
                [filteredUsers$]="filteredExperienceUsers$"
                [selectedUserId$]="selectedUserIds$"
                [searchTerm$]="searchTerm$"
                (select)="selectUser($event)"
                (toggle)="masterToggle($event)"
                [totalCount$]="totalCount$"
            >
            </app-experience-users-list>
        </div>

        <ng-template #spinner>
            <div class="p-24 white" fxLayout="column" fxLayoutAlign="center center">
                <div class="p-24">
                    <mat-spinner></mat-spinner>
                </div>
            </div>
        </ng-template>
    </div>
</div>
